import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class Template {
  constructor() {
    this.data = {};
  }

  async getData(Type) {
    this.data = (await fetchApi.get(`/attributeTemplate?type=${Type}`)).data.data;
    return this.data;
  }

  getAttributeTemplateOptions() {
    let templateOptions = [];

    if (Object.keys(this.data).length > 0) {
      Object.keys(this.data).forEach((key) => {
        templateOptions[key] = {};
        templateOptions[key]["name"] = this.data[key].name;
        templateOptions[key]["modifiedBy"] = this.data[key].ModifiedBy;
        templateOptions[key]["lastModified"] = this.data[key].UpdatedDate;
        templateOptions[key]["id"] = this.data[key].Template_id;
      });
    }
    return templateOptions;
  }

  async createAttributeTemplate(templateJson) {
    return (await fetchApi.post(`/attributeTemplate`, templateJson)).data;
  }

  async updateAttributeTemplate(templateId, templateJson) {
    return (await fetchApi.patch(`/attributeTemplate/${templateId}`, { detail: templateJson })).data;
  }

  async upload(formData) {
    const response = await fetchApi.postFormData(`/attributeTemplate/upload`, formData);

    return response.data;
  }

  async download(templateId, templateName) {
    return await fetchApi.download(`/attributeTemplate/${templateId}`, {
      fileName: `${templateName}.json`,
    });
  }

  async delete(templateId) {
    return (await fetchApi.delete(`/attributeTemplate/${templateId}`)).data;
  }
}
